import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const FileExcelIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path fill="#26A358" d="M0 0h24v24H0z" />
        <path fill="#FFF" d="M8 2.667v18.666h2.667V2.667z" />
        <path fill="#FFF" d="M21.333 10.667H2.667V8h18.666z" />
      </g>
    </SvgIcon>
  );
};
